import * as colors from './colors';

export type ThemeType = typeof theme;

export const theme = {
    colors,
    fonts: {
        headline: 'Dinpro, helvetica, arial, sans-serif',
        body: 'Dinpro, helvetica, arial, sans-serif',
        mono: 'monospace',
    },
    fontWeights: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    fontSizes: {
        ant: '10px',
        beetle: '12px',
        frog: '13px',
        mouse: '14px',
        rat: '15px',
        guinea: '16px',
        squirrel: '17px',
        chicken: '18px',
        cat: '22px',
        wolf: '27px',
        bear: '30px',
        hippo: '35px',
        elephant: '40px',
        whale: '50px',
    },
    lineHeights: {
        mosquito: '11px',
        beetle: '12px',
        frog: '13px',
        mouse: '14px',
        rat: '15px',
        guinea: '16px',
        squirrel: '17px',
        chicken: '18px',
        owl: '20px',
        turkey: '21px',
        cat: '22px',
        fox: '23px',
        dog: '24px',
        coyote: '25px',
        wolf: '27px',
        bear: '30px',
        hippo: '35px',
        elephant: '40px',
        mammoth: '45px',
    },
    space: {
        '1': '5px',
        '2': '10px',
        '3': '15px',
        '4': '20px',
        '5': '30px',
        '6': '40px',
        '7': '50px',
        '8': '60px',
        '9': '70px',
        '10': '80px',
        '11': '90px',
        '12': '100px',
        gutter: 'min(6vw, 115px)',
    },
    sizes: {
        // Limit content
        contentMaxWidth: 1440,

        // Limit page width. Background colors etc.
        pageMaxWidth: 1680,

        content: 'min(88vw, 1690px)',
    },
    navigationOffsetTop: {
        desktop: 120,
        mobile: 20,
    },
    zIndices: {
        '1': 100,
        '2': 200,
        '3': 300,
        '4': 400,
        max: 999,

        searchField: 175,
        searchButtons: 200,
        searchResult: 150,
        mainNavigation: 400,
        mainNavigationContent: 300,
        background: 300,
        miniBasket: 290,
        modalContent: 100,
    },
    easings: {
        smoothEase: 'cubic-bezier(0.35, 0, 0.15, 1)',
    },
    shadows: {
        content: '0 5px 14px 0 rgba(0,0,0,0.2)',
    },
} as const;
